// Display evidence only. Never supplies answers, a verdict, or an exhaustive set.
export function observableCandidateBranches(tree) {
  const d = tree?.product_fact_dialogue;
  const p = tree?.observable_preview;
  if (tree?.action !== 'ask' || d?.status !== 'needs_product_facts' || d.document_requests?.length
    || p?.kind !== 'observable_branch_guide' || p.final !== false || !Array.isArray(p.branches)) return [];
  return p.branches.filter(b => /^\d{4}$/.test(b.hs4) && /^\d{6}$/.test(b.hs6) && b.hs6.startsWith(b.hs4)
    && b.source_ref && Array.isArray(b.conditions) && b.conditions.length
    && b.conditions.every(c => c.fact_key && c.question && c.answer));
}

export function observableCandidateRequirements(tree) {
  const branches = observableCandidateBranches(tree);
  const result = {};
  const byCode = new Map();
  branches.forEach(b => { if (!byCode.has(b.hs6)) byCode.set(b.hs6, []); byCode.get(b.hs6).push(b); });
  for (const [hs6, alternatives] of byCode) {
    const row = (key, prompt, label, status = 'open') => ({ key, prompt, level: 'hs6', options: [{ value: '', label }], status, readOnly: true });
    // Distinct routes are alternatives, not an invented conjunction of facts.
    const requirements = alternatives.length === 1
      ? alternatives[0].conditions.map(c => row(`preview:${c.fact_key}`, c.question, c.answer, c.confirmed ? 'ok' : 'open'))
      : [row(`preview:routes:${hs6}`, '다음 대체 경로 중 하나의 조건 확인', alternatives.map((b, i) => `경로 ${i + 1}: ${b.conditions.map(c => `${c.question} ${c.answer}`).join(' · ')}`).join(' 또는 '))];
    requirements.push(row(`preview:source:${hs6}`, '주요 갈림 조건의 근거 · 전체 법적 확인은 별도', [...new Set(alternatives.map(b => b.source_ref))].join(' · ')));
    result[hs6] = requirements;
    for (const b of alternatives) for (const o of b.domestic_options || []) {
      if (!/^\d{10}$/.test(o.code) || !o.code.startsWith(hs6) || !o.label) continue;
      result[o.code] = [...requirements, row(`preview:domestic:${o.code}`, '국내세분 문언 · 실제 해당 여부 확인 필요', o.label + (o.residual ? ' · 다른 세분에 해당하지 않는지 확인 필요' : ''))];
    }
  }
  return result;
}
